import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const DownloadIcon = forwardRef<SVGSVGElement, IconProps>(function DownloadIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35355 8.56754C6.15829 8.78056 5.84171 8.78056 5.64645 8.56754L3.14645 5.84026C2.95118 5.62725 2.95118 5.28188 3.14645 5.06887C3.34171 4.85586 3.65829 4.85586 3.85355 5.06887L5.5 6.865V0.545457C5.5 0.244209 5.72386 -2.63359e-08 6 0C6.27614 2.63359e-08 6.5 0.244209 6.5 0.545457V6.865L8.14645 5.06887C8.34171 4.85586 8.65829 4.85586 8.85355 5.06887C9.04882 5.28189 9.04882 5.62725 8.85355 5.84026L6.35355 8.56754Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.88874C2.5 2.52473 2.18436 2.25327 1.87433 2.38785C0.403478 3.02632 0 4.35354 0 6.93043C0 11.1052 1.059 12 6 12C10.941 12 12 11.1052 12 6.93043C12 4.35354 11.5965 3.02633 10.1257 2.38785C9.81565 2.25327 9.5 2.52473 9.5 2.88874C9.5 3.13554 9.65044 3.34726 9.85699 3.44794C10.0137 3.5243 10.1388 3.60663 10.2405 3.69258C10.7095 4.08878 11 4.84478 11 6.93043C11 9.01609 10.7095 9.77208 10.2405 10.1683C9.97879 10.3894 9.56189 10.5866 8.85235 10.7199C8.14307 10.853 7.21798 10.9091 6 10.9091C4.78202 10.9091 3.85693 10.853 3.14765 10.7199C2.43811 10.5866 2.02121 10.3894 1.75946 10.1683C1.29054 9.77208 1 9.01609 1 6.93043C1 4.84478 1.29054 4.08878 1.75946 3.69258C1.86118 3.60663 1.98635 3.5243 2.14301 3.44794C2.34956 3.34726 2.5 3.13554 2.5 2.88874Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
